<template>
  <div :class="$style.presentationDialog">
    <div>
      <div class="text-center mb-3">
        <img src="@/assets/img/trail/trail-icon.png" alt="Ícone trilha"/>
      </div>

      <div style="flex: 1">
        <h3 :class="$style.presentationDialog__header" class="mb-3">
          Trilha do sucesso
        </h3>

        <div :class="$style.presentationDialog__description" class="mb-4">
          Descubra as habilidades digitais que mais se adequam ao seu perfil e acompanhe o progresso rumo aos seus objetivos!
        </div>

        <div class="text-center d-flex flex-column align-items-center">
          <router-link
            :to="{ name: 'trail.pick' }"
            class="mb-2"
            :class="$style.presentationDialog__button"
            @click.native="pick"
          >
            Escolher minha trilha
          </router-link>

          <button
            type="submit"
            :class="$style.presentationDialog__button2"
            @click="dismiss"
          >escolher depois</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup(props, { emit }) {
    function dismiss () {
      const timestamp = Math.round((new Date).getTime() / 1000)
      localStorage.setItem('trailDialogDismissTime', timestamp)
      emit('close')
    }

    function pick () {
      emit('close')
    }

    return {
      dismiss,
      pick
    }
  }
}
</script>

<style lang="scss" scoped module>
@import "~@/assets/sass/variables";

.presentationDialog {
  position: relative;
  z-index: 1;
  padding: 1.5rem;
  border-radius: 8px;
  background: $yellowBorder;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: inherit;
    background: $borderGradient;
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
  }

  &__header {
    text-align: center;
  }

  &__description {
    text-align: center;
    font-size: 1.0625rem;
  }

  &__button {
    color: $white300;
    font-size: 0.89rem;
    padding: 12px 24px;
    border-radius: 4px;
    border: 1px solid $yellowBorder;
    background: radial-gradient(56.27% 117.62% at 37.5% 100%, rgba(255, 255, 255, 0.29) 0%, rgba(255, 255, 255, 0.05) 100%), radial-gradient(108.23% 146.28% at 50% 0%, rgba(32, 32, 32, 0.00) 11.38%, rgba(91, 0, 105, 0.70) 68.27%), radial-gradient(178.09% 220.16% at 94.89% -132.81%, #9000F0 67.59%, rgba(253, 212, 155, 0.38) 100%), #000;
    box-shadow: 0px 0px 4px 0px #FFF inset;

    &:hover {
      border: 1px solid rgba(255, 222, 91, 0.05);
      background: radial-gradient(56.27% 117.62% at 37.5% 100%, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.02) 100%), radial-gradient(108.23% 146.28% at 50% 0%, rgba(32, 32, 32, 0.00) 11.38%, rgba(91, 0, 105, 0.70) 68.27%), radial-gradient(178.09% 220.16% at 94.89% -132.81%, #9000F0 67.59%, rgba(253, 212, 155, 0.38) 100%), #000;
    }

    &:focus {
      border: 1px solid rgba(255, 222, 91, 0.01);
      background: radial-gradient(108.23% 146.28% at 50% 0%, rgba(32, 32, 32, 0.00) 11.38%, rgba(91, 0, 105, 0.70) 68.27%), radial-gradient(178.09% 220.16% at 94.89% -132.81%, rgba(144, 0, 240, 0.70) 67.59%, rgba(253, 212, 155, 0.27) 100%), #000;
    }
  }

  &__button2 {
    padding: 8px 0;
  }
}
</style>